import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import Navigation from "./Components/Navigation";

import Home from "./Pages/Home";
import Tool from "./Pages/Tool";
import What from "./Pages/What";
import How from "./Pages/How";

import Privacy from "./Pages/Privacy";
import Terms from "./Pages/Terms";
import Contact from "./Pages/Contact";
import NotFound from "./Pages/NotFound";
import Footer from "./Components/Footer";

function App() {
  return (
    <Router>
      <Navigation />

      {/* optional: adds spacing so content isn't hidden behind fixed navbar */}
      <div style={{ paddingTop: "72px" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tool" element={<Tool />} />
          <Route path="/what-is-json" element={<What />} />
          <Route path="/how-it-works" element={<How />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;